import { memo } from "react";

import { useCanvasApi } from "../../../context/CanvasContext";
import type { WidgetNodeProps } from "../../../types/canvasNodeData";
import { VoteFace } from "./VoteFace";
import {
  castVote,
  voteKey,
  voteOf,
  votesOf,
  type VoteValue,
} from "./voteState";

export const VoteWidget = memo(function VoteWidget({
  id,
  data,
}: WidgetNodeProps) {
  const { canEdit, self, updateNodeData, removeNodeDataKey } = useCanvasApi();
  const fields = data as Record<string, unknown>;
  const votes = votesOf(fields);
  const question = typeof fields.question === "string" ? fields.question : "";
  // No self outside a room: the public viewer shows the results only.
  if (!self) {
    return <VoteFace votes={votes} mine={null} question={question} readOnly />;
  }

  const mine = voteOf(fields, self.id);
  // Your current side again takes the vote back; the other side switches it.
  const vote = (value: VoteValue) => {
    if (mine === value) removeNodeDataKey(id, voteKey(self.id));
    else updateNodeData(id, castVote(self.id, self, value, Date.now()));
  };
  const ask = (next: string) => {
    if (next === question) return;
    if (next) updateNodeData(id, { question: next });
    else removeNodeDataKey(id, "question");
  };

  return (
    <VoteFace
      votes={votes}
      mine={mine}
      question={question}
      onVote={canEdit ? vote : undefined}
      onQuestion={canEdit ? ask : undefined}
    />
  );
});
